/**
 * 请求域名处理环境判断
 */
var reqHostName = function () {
  let _origin
  if(window.location.hostname === '0.0.0.0' || window.location.hostname === 'spcare.medbanks-test.cn'){
    _origin = 'https://test-product-config-1300562124.file.myqcloud.com'
  } else if(window.location.hostname === 'spcare.medbanks-test.com'){
    _origin = 'https://test-product-config-1300562124.file.myqcloud.com'
  } else {
    _origin = 'https://prod-product-config-1300562124.file.myqcloud.com'//生产域名 https://gateway.ytbxjj.com
  }
    return _origin;
}
export default reqHostName;